import type { IdleAnimation } from "../types";
import type { ReactionId } from "./emotionCatalog";

const FALLBACK_ART = "/art/happy_affirm.png";

export const REACTION_ART: Record<ReactionId, string> = {
  triumph_wooo: "/art/triumph_wooo.png",
  happy_affirm: "/art/happy_affirm.png",
  happy_laugh: "/art/happy_laugh.png",
  sad_sigh: "/art/sad_sigh.png",
  sad_wailing: "/art/sad_wailing.png",
  fear_gasp: "/art/fear_gasp.png",
  fear_scream: "/art/fear_scream.png",
  anger_growl: "/art/anger_growl.png",
  anger_shout: "/art/anger_growl.png",
  disgust_tongue: "/art/disgust_tongue.png",
  disgust_yuck: "/art/disgust_yuck.png",
  surprise_inhale: "/art/surprise_inhale.png",
  contempt_tsk: "/art/contempt_tsk.png",
  contempt_snort: "/art/contempt_snort.png",
  confused: "/art/confused.png",
  sleepy_snore: "/art/sleepy_snore.png",
  eating_munch: "/art/eating_munch.png"
};

export const BACKGROUND_IMAGES = {
  default: "/art/bg_default.png",
  quantum: "/art/bg_quantum.png"
};

export const ACCESSORY_ART = {
  finance: "/art/state_finance.png"
};

export const IDLE_ART: Record<Exclude<IdleAnimation, "none">, string> = {
  reading: "/art/idle_reading.png"
};

export const THINKING_ART = "/art/thinking4.png";

export function getReactionArt(reaction: ReactionId | null): string {
  if (!reaction) {
    return FALLBACK_ART;
  }
  return REACTION_ART[reaction] ?? FALLBACK_ART;
}
